import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
export default function addProfilePane() {
  extend(UserPage.prototype, 'navItems', function (items) {
    if (app.forum.attribute('canViewMasquerade') || this.user?.canEditMasqueradeProfile()) {
      const edit = this.user?.canEditMasqueradeProfile();
      items.add('masquerade', m(LinkButton, {
        href: app.route('fof-masquerade', {
          username: this.user?.slug()
        }),
        icon: "far fa-id-card",
        "data-edit-profile": edit
      }, app.translator.trans(`fof-masquerade.forum.buttons.${edit ? 'edit' : 'view'}-profile`)), 200);
    }
  });
}